import { createContext } from 'react';

export const AuthContext = createContext({
  isLoggedIn: false,
  userId: null,
  userName: null,
  token: null,
  role: null,
  login: () => {},
  logout: () => {}
});

export const SignupContext = createContext({
  isSignup: false,
  signup: () => {},
});
// // export const AdminAuthContext = createContext({
// //   isAdminLoggedIn: false, 
// //   adminId: null,
// //   adminName: null,
// //   adminToken: null,
// //   role: null,
// //   adminLogin: () => {},
// //   adminLogout: () => {}
// // });

export const uploadMethod = createContext({
  upload: () => {},
  isValid: false
});

